import RequestTrailList from "./RequestTrailList";
import RequestLevels from "./RequestLevels";
import {forwardRef, useImperativeHandle} from "react";
import {RequestTabApp} from "../Functionality/RequestTabApp";
import NotInformation from "../../../../components/NotInformation";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 * Created At: 05/12/2025
 */

const RequestTab = forwardRef(({
                                   t,
                                   userId,
                                   modified,
                                   setModified,
                                   documentationApproval,
                                   profile,
                                   period,
                                   setPeriod,
                                   setDocumentationApproval,
                               }, ref) => {

    const {
        item,
        getStatusIcon,
        handleChange,
        emptyFields,
        showModal,
        setShowModal,
        photoPicker,
        setPhotoPicker,
        elementRef,
        handleSaveDraft,
        handleSubmitSave,
        setActiveLevelIndex,
        onFileSelected,
        levelRefsRef,
        handleSelectLevel,
        highlightedLevel,
        availableHeightColumnOneRef,
        availableHeightColumnTwoRef,
        containerHeightRef
    } = RequestTabApp({
        modified,
        setModified,
        userId,
        profile,
        period,
        setPeriod,
        setDocumentationApproval
    });
    useImperativeHandle(ref, () => ({
        handleSaveDraft,
        handleSubmitSave,
    }));

    return (
         (period && item?.id !== null) ? (
             <div className={"row"} ref={elementRef}>
                 <div className={"col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12"} ref={availableHeightColumnOneRef}>
                     <RequestTrailList
                         item={item}
                         getStatusIcon={getStatusIcon}
                         elementRef={elementRef}
                         levelRefsRef={levelRefsRef}
                         period={period}
                         onSelectLevel={handleSelectLevel}
                     />

                 </div>
                 <div className={"col-xl-8 col-lg-8 col-md-12 col-sm-12 col-12 mt-xl-0 mt-lg-0 mt-md-5 mt-sm-5"} ref={availableHeightColumnTwoRef}>
                     <RequestLevels
                         t={t}
                         item={item}
                         handleChange={handleChange}
                         emptyFields={emptyFields}
                         showModal={showModal}
                         setShowModal={setShowModal}
                         photoPicker={photoPicker}
                         setPhotoPicker={setPhotoPicker}
                         setActiveLevelIndex={setActiveLevelIndex}
                         onFileSelected={onFileSelected}
                         levelRefsRef={levelRefsRef}
                         period={period}
                         documentationApproval={documentationApproval}
                         highlightedLevel={highlightedLevel}
                         containerHeightRef={containerHeightRef}
                     />
                 </div>
             </div>
             ):(
                 <NotInformation card={true} text={t('there_not_period_active')} />
             )



    )
});

export default RequestTab
